/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSimulationNeedsMutation from '../graphql/mutations/SaveSimulationNeedsMutation.js';

export const useSaveSimulationNeedsMutation = () => {
  return useCommitMutation(SaveSimulationNeedsMutation, {
    dataProp: 'saveSimulationNeeds_M_simulation_needs'
  });
};

export default useSaveSimulationNeedsMutation;
